import Vue from 'vue'
import VueRouter from 'vue-router'
import frist from '../views/frist.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    component: frist,
  },
]

const router = new VueRouter({
  routes
})

export default router
